"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetInvoiceHeader = class FieldsetInvoiceHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onReferenceInvoiceSelected(...args) {
        const { option, value } = args[0];
        this.selectClient({ clientId: option.client.id });
    }
    selectClient(...args) {
        const { clientId } = args[0];
        return this.$fn
            .fetch('get_invoice_party_details', { parameters: { id: clientId } })
            .then(data => this.setData('invoice.client', data))
            .catch(err => this.onError(err));
    }
    selectCompany(...args) {
        const { companyId } = args[0];
        return this.$fn
            .fetch('get_invoice_party_details', { parameters: { id: companyId } })
            .then(data => this.setData('invoice.company', data))
            .catch(err => this.onError(err));
    }
    checkInvoiceNumber(...args) {
        const invoiceNumber = args[0];
        return this.$fn
            .fetch('check', { parameters: { kind: 'invoice', op: 'exists', query: invoiceNumber, partner_id: _.get(this.invoice, 'client.id') } })
            .then(d => this.duplicateInvoiceNumber = d.passed)
            .catch(err => this.duplicateInvoiceNumber = false);
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    messages;
    editCompany;
    editClient;
    duplicateInvoiceNumber;
    currencies;
    async $$load_currencies() {
        return this.$app.repo.get('list_currency');
    }
    paymentMethods;
    async $$load_paymentMethods() {
        return this.$app.repo.get('list_payment_method')
            .then(data => _.map(data, p => ({
            value: p.id,
            text: this.$fn.pgettext('PaymentMethod', p.name)
        })));
    }
    expenseTypes;
    async $$load_expenseTypes() {
        return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'expense-type' } });
    }
    invoiceStatuses;
    async $$load_invoiceStatuses() {
        return this.$fn.getEnumValuesFromSchema(this.isIncomingInvoice ? 'IncomingInvoiceStatus' : 'OutgoingInvoiceStatus', { sort: false });
    }
    incomingInvoiceStatuses;
    async $$load_incomingInvoiceStatuses() {
        return this.$fn.getEnumValuesFromSchema('IncomingInvoiceStatus', { sort: false });
    }
    invoiceTypes;
    async $$load_invoiceTypes() {
        return this.$fn.getEnumValuesFromSchema('InvoiceType', { sort: false });
    }
    languages;
    tags;
    async $$load_tags() {
        return this.$app.repo.get('get_tags', { parameters: { tag_type: 'invoice' } }).then(data => _.map(data, p => p.name));
    }
    vatPeriods;
    async $$load_vatPeriods() {
        return this.$app.repo.get('list_vat_periods');
    }
    templates;
    async $$load_templates() {
        return this.$app.repo.get('list_template')
            .then(items => _.filter(items, { object_type: 'invoice_notification' }));
    }
    ux;
    b_6917646200545441_dataSource;
    b_6424600534600827_dataSource;
    dataMembers = ['messages', 'editCompany', 'editClient', 'duplicateInvoiceNumber', 'currencies', 'paymentMethods', 'expenseTypes', 'invoiceStatuses', 'incomingInvoiceStatuses', 'invoiceTypes', 'languages', 'tags', 'vatPeriods', 'templates', 'ux', 'b_6917646200545441_dataSource', 'b_6424600534600827_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    invoiceTypes: {
                        correction: this.$fn.pgettext("InvoiceType", "Correction"),
                        storno: this.$fn.pgettext("InvoiceType", "Storno"),
                        proforma: this.$fn.pgettext("InvoiceType", "Pro Forma"),
                    },
                    invoiceTypeHelp: {
                        normal: this.$fn.pgettext("Invoice|Reference|description", "Normal invoices can reference Pro Forma invoices."),
                        correction: this.$fn.pgettext("Invoice|Reference|description", "A correction must reference the invoice being corrected."),
                        storno: this.$fn.pgettext("Invoice|Reference|description", "The reversing invoice must reference the invoice being reversed."),
                        proforma: this.$fn.pgettext("Invoice|Reference|description", "Pro Forma invoices can reference former Pro Forma invoices."),
                    },
                    duplicateInvoiceNumber: this.$fn.pgettext("Invoice", "The given invoice number already exists."),
                },
                editCompany: false,
                editClient: false,
                duplicateInvoiceNumber: false,
                currencies: null,
                paymentMethods: null,
                expenseTypes: null,
                invoiceStatuses: null,
                incomingInvoiceStatuses: null,
                invoiceTypes: null,
                languages: [{
                        value: "hu",
                        text: this.$fn.pgettext("Language", "hungarian"),
                    },
                    {
                        value: "en",
                        text: this.$fn.pgettext("Language", "english"),
                    },
                ],
                tags: null,
                vatPeriods: null,
                templates: null,
                ux: null,
                b_6917646200545441_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "own",
                    },
                },
                b_6424600534600827_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                    },
                },
            },
        };
    }
    get isReadonly() {
        if (this.loaded) {
            return false;
        }
        return null;
    }
    get isIncomingInvoice() {
        if (this.loaded) {
            return this.invoice.invoice_kind == 'incoming';
        }
        return null;
    }
    get isReferenceInvoiceRequired() {
        if (this.loaded) {
            return ['storno', 'correction'].indexOf(this.invoice.invoice_type) > -1;
        }
        return null;
    }
    get preventChangeClient() {
        if (this.loaded) {
            return !!this.invoice.reference_invoice;
        }
        return null;
    }
    get preventChangeCompany() {
        if (this.loaded) {
            return !!this.invoice.reference_invoice;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_script_6992_getActionArgs_value($event) {
        this.onReferenceInvoiceSelected($event.data);
    }
    async act_4186377094414664_script_6992_getActionArgs($event) {
        return {
            value: () => this.act_4186377094414664_script_6992_getActionArgs_value($event),
        };
    }
    async evh_4186377094414664_optionSelected(event, scope) {
        return await this.actions.evh_4186377094414664_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_6917646200545441_script_6994_getActionArgs_value($event) {
        this.selectCompany({ companyId: this.invoice.company.id });
    }
    async act_6917646200545441_script_6994_getActionArgs($event) {
        return {
            value: () => this.act_6917646200545441_script_6994_getActionArgs_value($event),
        };
    }
    async act_6917646200545441_script_6994_getWhen($event) {
        return !!this.invoice.company;
    }
    async evh_6917646200545441_selected(event, scope) {
        return await this.actions.evh_6917646200545441_selected.executeFromDOM(this, event, scope);
    }
    async act_6424600534600827_script_6996_getActionArgs_value($event) {
        this.selectClient({ clientId: this.invoice.client.id });
    }
    async act_6424600534600827_script_6996_getActionArgs($event) {
        return {
            value: () => this.act_6424600534600827_script_6996_getActionArgs_value($event),
        };
    }
    async act_6424600534600827_script_6996_getWhen($event) {
        return !!this.invoice.client;
    }
    async evh_6424600534600827_selected(event, scope) {
        return await this.actions.evh_6424600534600827_selected.executeFromDOM(this, event, scope);
    }
    async act_2754826507016131_script_6998_getActionArgs_value($event) {
        this.checkInvoiceNumber(this.invoice.invoice_number);
    }
    async act_2754826507016131_script_6998_getActionArgs($event) {
        return {
            value: () => this.act_2754826507016131_script_6998_getActionArgs_value($event),
        };
    }
    async evh_2754826507016131_blur_6997_getWhen($event) {
        return this.invoice.isValueChanged('invoice_number');
    }
    async evh_2754826507016131_blur(event, scope) {
        return await this.actions.evh_2754826507016131_blur.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_6990 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_6989 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_6990,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_6989],
        });
        const act_4186377094414664_script_6992 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4186377094414664_script_6992_getActionArgs,
            events: [],
        });
        const evh_4186377094414664_optionSelected_6991 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_script_6992,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_4186377094414664_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_optionSelected_6991],
        });
        const act_6917646200545441_script_6994 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6917646200545441_script_6994_getActionArgs,
            when: this.act_6917646200545441_script_6994_getWhen,
            events: [],
        });
        const evh_6917646200545441_selected_6993 = new core_1.actions.EventHandlerImpl({
            action: act_6917646200545441_script_6994,
            event: "selected",
            displayName: "script",
        });
        const evh_6917646200545441_selected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6917646200545441_selected_6993],
        });
        const act_6424600534600827_script_6996 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6424600534600827_script_6996_getActionArgs,
            when: this.act_6424600534600827_script_6996_getWhen,
            events: [],
        });
        const evh_6424600534600827_selected_6995 = new core_1.actions.EventHandlerImpl({
            action: act_6424600534600827_script_6996,
            event: "selected",
            displayName: "script",
        });
        const evh_6424600534600827_selected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6424600534600827_selected_6995],
        });
        const act_2754826507016131_script_6998 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2754826507016131_script_6998_getActionArgs,
            events: [],
        });
        const evh_2754826507016131_blur_6997 = new core_1.actions.EventHandlerImpl({
            action: act_2754826507016131_script_6998,
            event: "blur",
            when: this.evh_2754826507016131_blur_6997_getWhen,
            displayName: "script",
        });
        const evh_2754826507016131_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2754826507016131_blur_6997],
        });
        return {
            act_7315092382398562_reloadComponentData_6990,
            evh_7315092382398562_reload_6989,
            evh_7315092382398562_reload,
            act_4186377094414664_script_6992,
            evh_4186377094414664_optionSelected_6991,
            evh_4186377094414664_optionSelected,
            act_6917646200545441_script_6994,
            evh_6917646200545441_selected_6993,
            evh_6917646200545441_selected,
            act_6424600534600827_script_6996,
            evh_6424600534600827_selected_6995,
            evh_6424600534600827_selected,
            act_2754826507016131_script_6998,
            evh_2754826507016131_blur_6997,
            evh_2754826507016131_blur,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetInvoiceHeader.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetInvoiceHeader.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetInvoiceHeader.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetInvoiceHeader.prototype, "onLabel_align", null);
FieldsetInvoiceHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetInvoiceHeader);
exports.default = FieldsetInvoiceHeader;
vue_property_decorator_1.Vue.component("FieldsetInvoiceHeader", FieldsetInvoiceHeader);
